import type { ProductSkuFragment } from '@/graphql/saleor/api';

export const getPricingFormProductChannelListing = (
  product: ProductSkuFragment,
  channel: string,
) => {
  const listing = product.channelListings?.find(
    (listing) => listing.channel.name.toLowerCase() === channel.toLowerCase(),
  );
  return listing?.pricing?.priceRange?.start;
};
